import axios from 'axios';
import envConfig from "../config/envConfig.js";


const apiService = axios.create({
    baseURL: `${envConfig.API_URL}/`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true, // Include the cookies in the request
});

export default apiService;